import axios from "axios";
const axiosLogin = axios.create();
axiosLogin.defaults.baseURL = process.env.VUE_APP_AUTH_API_URL;
export {
    axiosLogin
};
